import { Controller } from '@coveo/atomic-react';
import { useEffect, useRef, useState } from 'react';

/**
 * Generic hook that wraps any Coveo Headless controller.
 * Subscribes to controller state changes and re-renders the component.
 * Unsubscribes on unmount to prevent memory leaks.
 */
export function useController<T extends Controller>(controller: T): T['state'] {
  const [state, setState] = useState(controller.state);
  const controllerRef = useRef(controller);

  useEffect(() => {
    // Only sync state if the controller identity changed
    if (controllerRef.current !== controller) {
      controllerRef.current = controller;
      setState(controller.state);
    }

    const unsubscribe = controller.subscribe(() => {
      setState(controller.state);
    });

    return () => {
      unsubscribe();
    };
  }, [controller]);

  return state;
}
